import React from "react";
import { useLocation } from "react-router-dom";
import BuyLabels  from "components/Shipements/BuyLabels";

function ShippingPreset() {
  const location = useLocation();
  
  // Determine the base route based on current location
  const isSignageTeammember = location.pathname.includes('/signageteammember');
  const baseRoute = isSignageTeammember ? '/signageteammember' : '/signage';
  
  // return <ShippingPresets baseRoute={baseRoute} />;
  return <BuyLabels   />;
}
export default ShippingPreset;
